import type { SavedDeckSummary } from './supabase';

export const MAX_BULK_DECKS = 500;
export const deckName = (name: string) => name.replace(/\.[^.]+$/, '').replace(/[-_]/g, ' ').replace(/\s+/g, ' ').trim();
export function sortLibraryDecks(decks: SavedDeckSummary[], sort: string) {
  const name = (a: SavedDeckSummary, b: SavedDeckSummary) => deckName(a.file_name).localeCompare(deckName(b.file_name), undefined, {numeric:true,sensitivity:'base'});
  return [...decks].sort((a,b) => {
    let result = 0;
    switch(sort) {
      case 'name-az': result=name(a,b); break;
      case 'name-za': result=name(b,a); break;
      case 'most-cards': result=b.card_count-a.card_count; break;
      case 'fewest-cards': result=a.card_count-b.card_count; break;
      case 'oldest': result=Date.parse(a.created_at)-Date.parse(b.created_at); break;
      case 'newest': result=Date.parse(b.created_at)-Date.parse(a.created_at); break;
      case 'modified-asc': result=Date.parse(a.updated_at)-Date.parse(b.updated_at); break;
      default: result=Date.parse(b.updated_at)-Date.parse(a.updated_at);
    }
    return result || name(a,b) || a.id.localeCompare(b.id);
  });
}
export function toggleDeckSelection(selected: string[], pageIds: string[], checked: boolean) {
  return checked ? [...new Set([...selected,...pageIds])].slice(0,MAX_BULK_DECKS) : selected.filter(id=>!pageIds.includes(id));
}
